/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/448-finder': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8.894 12.16v-.002.002zM8.916 12.727l-.001-.011.001.011zM8.903 12.442v-.008.008zM15 0H1C.45 0 0 .45 0 1v14c0 .55.45 1 1 1h14c.55 0 1-.45 1-1V1c0-.55-.45-1-1-1zM3 3.5a.5.5 0 011 0v1a.5.5 0 01-1 0v-1zM15 15H9.14a20.425 20.425 0 01-.209-1.994v.005a8.551 8.551 0 01-6.595-2.09.563.563 0 01.744-.844 7.426 7.426 0 005.807 1.806 31.808 31.808 0 01.11-3.334A.499.499 0 008.499 8H7.012c.022-.541.079-1.466.234-2.503.295-1.981.812-3.528 1.502-4.497h6.251v14z"/><path pid="1" d="M12.5 5a.5.5 0 01-.5-.5v-1a.5.5 0 011 0v1a.5.5 0 01-.5.5zM8.445 13.05zM8 13.063zM8.423 11.925l.037-.002-.037.002zM8.204 11.934a.803.803 0 00.05-.002l-.05.002zM13.713 10.128a.563.563 0 00-.794-.05 7.428 7.428 0 01-4.032 1.806c.007.364.02.742.043 1.127a8.552 8.552 0 004.733-2.09.563.563 0 00.05-.794zM8.93 13.012zM8.68 13.035l-.183.013.183-.013z"/>'
  }
})
